import { render } from "./UserInfoHome.vue?vue&type=template&id=e52b6ac0&scoped=true"
import script from "./UserInfoHome.vue?vue&type=script&lang=js"
export * from "./UserInfoHome.vue?vue&type=script&lang=js"

import "./UserInfoHome.vue?vue&type=style&index=0&id=e52b6ac0&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52b6ac0"]])

export default __exports__